module.exports = __webpack_public_path__ + "static/img/location.994fc818.png";